import { jwtDecode } from "jwt-decode";
import { useAuthStore } from "../stores/authStore";

/**
 * True while the token has more than `marginMs` left. Unreadable tokens count
 * as stale, and tokens without an `exp` claim never expire.
 */
export function isTokenFresh(token: string, marginMs = 0): boolean {
  try {
    const { exp } = jwtDecode<{ exp?: number }>(token);
    return exp === undefined || exp * 1000 - marginMs > Date.now();
  } catch {
    return false;
  }
}

export const isAuthenticated = (): boolean => {
  try {
    const decoded = jwtDecode(useAuthStore.getState().token || "");

    if (!decoded) return false;

    return true;
  } catch {
    return false;
  }
};
